
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11656',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11656",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.253",
  "data-fetching-client": "static-1.9509",
  "foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "static-1.4241",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7837",
  "hub-http-shared-msw-handlers": "static-1.9551",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11272",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6302",
  "marketplace-storefront-base": "static-1.11716",
  "quartz": "static-1.6774",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16482",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2695",
  "reporting-testing-lib": "static-1.8591",
  "settings-ui-lib": "static-1.12355",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6792",
  "ui-addon-i18n": "static-1.10975",
  "ui-addon-react-router-dom": "static-1.9377",
  "unified-auth": "static-1.259",
  "unified-auth-core-lib": "static-1.540",
  "usage-tracker": "static-1.7166",
  "usage-tracker-core": "static-1.7016",
  "customer-data-property-utils": "static-1.7911",
  "history": "static-4.47",
  "hub-http": "static-1.6050",
  "integrations-lib": "static-1.15533",
  "marketplace-ui-common": "static-1.19041",
  "property-management-iframe": "static-1.12464",
  "quartz-config": "static-1.552",
  "quartz-core": "static-1.5993",
  "quartz-routing": "static-1.204",
  "quick-fetch": "static-1.3768",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4466",
  "ts-schema": "static-1.3936",
  "ui-universal-auth": "static-1.8745",
  "UIComponents": "static-3.8219",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3258",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3051",
  "quartz-webpack": "static-1.2998",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4668",
  "foundations-theming-specialty": "static-1.1957",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9257",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5204",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1302",
  "ui-fonts": "static-1.534",
  "ui-images": "static-2.1105",
  "bend-plugin-foundations-theming": "static-1.2724",
  "foundations-theming-base": "static-1.3226",
  "stylex": "static-1.28",
  "HeadJS": "static-2.718",
  "hs-test-utils-bend-plugin": "static-1.2948",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4157",
  "ai-components-ui-library": "static-1.8439",
  "ai-rendering-library": "static-1.9401",
  "chirp-fetch": "static-1.1713",
  "connections-embed-lib": "static-1.683",
  "copilot-toolkit": "static-1.10616",
  "laboratory-lib": "static-3.6991",
  "marketplace-embed": "static-1.21560",
  "marketplace-ui-details": "static-1.8937",
  "marketplace-ui-reviews": "static-1.18997",
  "marketplace-ui-tracking": "static-1.13212",
  "sanitize-text": "static-1.7976",
  "ui-addon-video-player": "static-1.8528",
  "usage-tracker-multi": "static-1.5580",
  "usage-tracker-session-replay": "static-1.4852",
  "wootric-nps": "static-1.6816",
  "apollo-link-hub-http": "static-2.4482",
  "immer": "static-1.33",
  "immerable": "static-1.3986",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66658",
  "cssUtils": "static-1.744",
  "flux-actions": "static-1.311",
  "HubStyle": "static-2.11580",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10043",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10205",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7156",
  "icons": "static-2.625",
  "marketplace-ui-apps-core": "static-1.17574",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4352",
  "foundations-components-test-utils": "static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "static-1.449",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3562",
  "customer-data-objects": "static-1.7479",
  "property-translator": "static-1.5241",
  "frontend-preferences-client": "static-1.7756",
  "hs-promise-utils": "static-1.5424",
  "hubspot-apollo-client": "static-1.4711",
  "integrations-error-boundary-lib": "static-1.12948",
  "integrations-tracking-lib": "static-1.5420",
  "native-integrations-shared-strings": "static-1.7619",
  "reselect": "static-2.16",
  "sanitize": "static-1.4305",
  "superstore": "static-1.4602",
  "ui-shepherd-react": "static-3.9978",
  "ai-settings-ui-library": "static-1.7549",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4509",
  "immutable-less": "static-1.4486",
  "marketplace-ui-client-types": "static-1.16448",
  "nav-meta": "static-1.29017",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10071",
  "ui-addon-upgrades": "static-9.17701",
  "inbound-db-properties-service-client": "static-1.3704",
  "property-management-common": "static-1.4751",
  "ui-addon-iframeable": "static-1.8878",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.449",
  "quartz-head": "static-1.439",
  "quartz-test": "static-1.449",
  "quartz-tracking": "static-1.153",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2970",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20468",
  "ContentUtils": "static-1.67715",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2320",
  "customer-data-filters-ui": "static-1.39020",
  "customer-data-objects-ui-components": "static-1.12842",
  "customer-data-reference-ui-components": "static-1.12978",
  "embedded-academy-lib": "static-1.13657",
  "ExportDialog": "static-6.10219",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40737",
  "reporting-snowflake": "static-1.55276",
  "reporting-ui-components": "static-2.63929",
  "reporting-visualizations": "static-1.58734",
  "ui-addon-teams": "static-1.21282",
  "magpie-lib": "static-1.5425",
  "magpie-types": "static-1.4885",
  "simple-logging-lib": "static-1.2882",
  "navigation-components": "static-1.17380",
  "ai-studio-lib": "static-1.11086",
  "developer-experience-shared-components": "static-1.10324",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7823",
  "ui-tool-access": "static-1.9976",
  "usage-based-billing-components-lib": "static-1.8096",
  "usage-tracker-anonymous": "static-1.5583",
  "usage-tracker-public": "static-1.6977",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3451",
  "persist-promise": "static-1.3539",
  "reference-resolvers": "static-1.7993",
  "ui-extensibility-client-types": "static-1.3775",
  "hubspot-apollo-cache": "static-1.170",
  "universal-page-editor-lib": "static-1.2830",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2274",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4901",
  "purchase-motions-components": "static-1.5522",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1382",
  "crm-component-utils": "static-1.38559",
  "crm-properties-common-lib": "static-1.5704",
  "customer-data-properties": "static-1.50862",
  "framework-data-schema-resolvers": "static-1.6703",
  "reference-resolvers-lite": "static-1.7923",
  "navigation-messaging": "static-1.6707",
  "hubspotter-http-shared-msw-handlers": "static-1.9549",
  "cms-field-types": "static-1.4639",
  "content-icons-ui": "static-1.2167",
  "conversations-skeleton-state": "static-1.7079",
  "crm-message-bus": "static-1.42464",
  "customer-data-filters-ui-msw-helpers": "static-1.21455",
  "customer-data-ui-utilities": "static-1.9656",
  "FormUrlGenerator": "static-2.4557",
  "framework-builder-read-service-client": "static-1.3863",
  "framework-data-schema-quick-fetch": "static-1.6608",
  "multi-account-reference-resolvers": "static-1.804",
  "onboarding-tours": "static-1.16307",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13157",
  "academy-common-lib": "static-1.13117",
  "content-assistance-lib": "static-1.7495",
  "dashboard-lib": "static-1.80758",
  "file-manager-components": "static-1.22993",
  "getting-started-shared-tasks": "static-1.17976",
  "hubspot-prosemirror": "static-1.17694",
  "hubspot-prosemirror-plugins": "static-1.17686",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19526",
  "share-with-third-party-component-lib": "static-1.8525",
  "ui-addon-draggable": "static-3.4598",
  "ui-asset-management-lib": "static-1.10749",
  "ui-business-units-lib": "static-1.8860",
  "user-context": "static-1.4931",
  "growth-payments-core": "static-1.24822",
  "reporting-plugins": "static-1.10022",
  "reporting-reports": "static-1.66336",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.556",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28927",
  "react-codemirror": "static-1.10458",
  "apps-service-types": "static-1.3708",
  "oauth-service-types": "static-1.4078",
  "onboarding-scopes": "static-1.6295",
  "onboarding-tours-client": "static-1.4521",
  "platform-infra-nav-components": "static-1.7522",
  "subscription-experience-data-types": "static-1.14621",
  "crm-record-cards-service-types": "static-1.3474",
  "location-customization-utils-lib": "static-1.8666",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4331",
  "nav-client-types": "static-1.2188",
  "purchase-motions-api": "static-1.5525",
  "signup-constants": "static-1.18487",
  "signup-ui-url-generator": "static-2.7866",
  "trials-service-types": "static-1.3732",
  "card-properties-lib": "static-1.43620",
  "commerce-subscription-lib": "static-1.36551",
  "crm-actions": "static-1.6137",
  "crm-cards-data": "static-1.1283",
  "crm-cards-sdk": "static-1.43021",
  "customer-data-properties-shared-msw-handlers": "static-1.8878",
  "customer-data-tracking": "static-1.6714",
  "calling-global-api": "static-1.63791",
  "calling-internal-common": "static-1.31127",
  "calling-lifecycle-internal": "static-1.65173",
  "calling-lifecycle-messages": "static-1.57467",
  "commerce-products-lib": "static-1.8948",
  "conditional-properties-service-client": "static-1.3653",
  "crm-links": "static-1.6097",
  "external-options-client-types": "static-1.4014",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.511",
  "inbounddb-objects-service-types": "static-1.4078",
  "meetings-icalendar-utils-lib": "static-1.463",
  "multi-currency-client-types": "static-1.3547",
  "object-builder-ui-client": "static-1.48110",
  "pipeline-validation-client-types": "static-1.3820",
  "property-value-citations": "static-1.1476",
  "pulse": "static-1.347",
  "smart-property-lib": "static-1.6059",
  "tiered-pricing": "static-1.874",
  "ui-addon-form-validation": "static-1.10825",
  "crm-pipelines-api-client-types": "static-1.3996",
  "react-dnd-compat": "static-1.4452",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5189",
  "growth-onboarding-confetti": "static-1.2903",
  "growth-onboarding-next-action-utils": "static-1.1381",
  "onboarding-tours-utils": "static-1.373",
  "ui-shepherd-tracker": "static-1.7359",
  "academy-service-client": "static-1.3512",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28032",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8216",
  "video-components-external": "static-1.10668",
  "video-data-lib": "static-1.34326",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8398",
  "payment-link-components": "static-1.23029",
  "ui-addon-emoji-picker": "static-1.9718",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6869",
  "data-token-picker": "static-1.16098",
  "FileManagerLib": "static-1.38633",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5076",
  "getting-started-shared-tasks-store": "static-1.17094",
  "campaign-roi-lib": "static-1.8382",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.224",
  "eligibility-engine-service-types": "static-1.3013",
  "crm_data": "static-4.91350",
  "customer-data-sidebar": "static-2.45504",
  "enrichment-properties-lib": "static-1.15177",
  "commerce-billing-lib": "static-1.18586",
  "commerce-shared-components-lib": "static-1.18032",
  "commerce-tools-ui-lib": "static-1.9877",
  "crm-fe-perf": "static-1.22736",
  "calling-error-reporting": "static-1.31133",
  "shared-worker-versioning": "static-1.10870",
  "calling-usage-tracker": "static-1.6373",
  "voice-sms-access-library": "static-1.341",
  "commerce-permissions": "static-1.590",
  "products-iframe-lib": "static-1.7418",
  "products-ui-components-shared-msw-handlers": "static-1.9933",
  "directed-graph": "static-1.771",
  "event-emitter": "static-1.778",
  "breeze-intelligence-kit": "static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9634",
  "policy-lib": "static-1.6609",
  "react-tinymce": "static-1.54711",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9697",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53837",
  "tinymce-plugins": "static-1.56951",
  "tinymce-themes": "static-1.55807",
  "growth-onboarding-next-action-components": "static-1.1409",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6413",
  "content-media-composition-data-lib": "static-1.11570",
  "content-media-compositions": "static-2.15577",
  "media-bridge-lib": "static-1.18620",
  "commerce-tours-lib": "static-1.5764",
  "growth-onboarding-reliability": "static-1.4917",
  "sales-checkout-service-client": "static-1.3498",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21362",
  "sales-email-signature-service-client": "static-1.3674",
  "audio-components": "static-1.5659",
  "FileManagerCore": "static-1.38492",
  "FileManagerImages": "static-1.36144",
  "video-components": "static-1.12671",
  "crm_universal": "static-1.21715",
  "customer-data-email": "static-1.17725",
  "card-payment-highlight-lib": "static-1.36604",
  "card-subscription-highlight-lib": "static-1.38974",
  "commerce-contract-lib": "static-1.11319",
  "customer-data-content": "static-1.26928",
  "invoices-highlight-card-lib": "static-1.54135",
  "orders-highlight-card-lib": "static-1.20949",
  "products-highlight-card-lib": "static-1.17232",
  "project-storage": "static-1.4565",
  "quotes-highlight-card-lib": "static-1.71313",
  "crm-source-interpretation-lib": "static-1.5160",
  "utility-belt": "static-1.2371",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11490",
  "payments-enrollment-embed-lib": "static-1.22114",
  "customer-data-rte": "static-1.32522",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5413",
  "InboxConnectUtils": "static-4.14308",
  "payments-post-enroll-local-storage-lib": "static-1.4946",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37402",
  "calling-orchestration-schema": "static-1.35118",
  "sales-views-client-types": "static-1.4117",
  "hub-http-contrib": "static-1.2875",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39922",
  "ui-addon-sales-email": "static-1.5046",
  "layout-dnd-components": "static-1.12095",
  "layout-dnd-utils": "static-1.11070",
  "ui-brand-identity-lib": "static-1.14094",
  "NamespacedHubStyle": "static-2.8927",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4363",
  "video-embed": "static-1.35160",
  "social-insights-client-types": "static-1.21453",
  "sequences-lib": "static-1.7737",
  "ui-gdpr-components": "static-1.10179",
  "products-ui-components": "static-1.39467",
  "quotes-ui-lib": "static-1.80033",
  "SalesContentIndexUI": "static-3.8946",
  "accounting-integrations-ui-components": "static-1.6775",
  "invoices-ui-lib": "static-1.54151",
  "commerce-products-api": "static-1.2000",
  "SafeStorage": "static-1.4234",
  "invoices-iframe-lib": "static-1.56209",
  "quotes-modal-lib": "static-1.101990",
  "deal-intel-decorators": "static-1.1373",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7188",
  "draft-content-plugins": "static-1.27789",
  "ContentData": "static-1.67790",
  "layout-data-lib": "static-1.9395",
  "outpost": "static-1.4034",
  "sequences-client-types-lib": "static-1.7594",
  "commerce-tax-lib": "static-1.348",
  "property-description-translator": "static-1.3687",
  "FireAlarmUi": "static-1.4363",
  "sales-templates-service-types-lib": "static-1.4022",
  "commerce-analytics-service-client": "static-1.3486",
  "totals-ui-components": "static-1.23078",
  "deal-intel-utils": "static-1.1377",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14864",
  "advanced-menus-lib": "static-1.11835",
  "ui-memberships-settings-lib": "static-1.33539",
  "commerce-totals-service-types": "static-1.3671",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14863",
  "simple-menus-lib": "static-1.16380"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11656",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.253",
  "data-fetching-client": "/data-fetching-client/static-1.9509",
  "foundations-components": "/foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "foundations-theming": "/foundations-theming/static-1.4241",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7837",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9551",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11272",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6302",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11716",
  "quartz": "/quartz/static-1.6774",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16482",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2695",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8591",
  "settings-ui-lib": "/settings-ui-lib/static-1.12355",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6792",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10975",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9377",
  "unified-auth": "/unified-auth/static-1.259",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.540",
  "usage-tracker": "/usage-tracker/static-1.7166",
  "usage-tracker-core": "/usage-tracker-core/static-1.7016",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7911",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6050",
  "integrations-lib": "/integrations-lib/static-1.15533",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19041",
  "property-management-iframe": "/property-management-iframe/static-1.12464",
  "quartz-config": "/quartz-config/static-1.552",
  "quartz-core": "/quartz-core/static-1.5993",
  "quartz-routing": "/quartz-routing/static-1.204",
  "quick-fetch": "/quick-fetch/static-1.3768",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4466",
  "ts-schema": "/ts-schema/static-1.3936",
  "ui-universal-auth": "/ui-universal-auth/static-1.8745",
  "UIComponents": "/UIComponents/static-3.8219",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3258",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3051",
  "quartz-webpack": "/quartz-webpack/static-1.2998",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4668",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1957",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9257",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5204",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1302",
  "ui-fonts": "/ui-fonts/static-1.534",
  "ui-images": "/ui-images/static-2.1105",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2724",
  "foundations-theming-base": "/foundations-theming-base/static-1.3226",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.718",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2948",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4157",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8439",
  "ai-rendering-library": "/ai-rendering-library/static-1.9401",
  "chirp-fetch": "/chirp-fetch/static-1.1713",
  "connections-embed-lib": "/connections-embed-lib/static-1.683",
  "copilot-toolkit": "/copilot-toolkit/static-1.10616",
  "laboratory-lib": "/laboratory-lib/static-3.6991",
  "marketplace-embed": "/marketplace-embed/static-1.21560",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8937",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18997",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13212",
  "sanitize-text": "/sanitize-text/static-1.7976",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8528",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5580",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4852",
  "wootric-nps": "/wootric-nps/static-1.6816",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4482",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3986",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66658",
  "cssUtils": "/cssUtils/static-1.744",
  "flux-actions": "/flux-actions/static-1.311",
  "HubStyle": "/HubStyle/static-2.11580",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10043",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10205",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7156",
  "icons": "/icons/static-2.625",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17574",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4352",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-jhardy-popover-allow-cross-axis-shift.9",
  "quartz-i18n": "/quartz-i18n/static-1.449",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3562",
  "customer-data-objects": "/customer-data-objects/static-1.7479",
  "property-translator": "/property-translator/static-1.5241",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7756",
  "hs-promise-utils": "/hs-promise-utils/static-1.5424",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4711",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12948",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5420",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7619",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4305",
  "superstore": "/superstore/static-1.4602",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9978",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7549",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4509",
  "immutable-less": "/immutable-less/static-1.4486",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16448",
  "nav-meta": "/nav-meta/static-1.29017",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10071",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17701",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3704",
  "property-management-common": "/property-management-common/static-1.4751",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8878",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.449",
  "quartz-head": "/quartz-head/static-1.439",
  "quartz-test": "/quartz-test/static-1.449",
  "quartz-tracking": "/quartz-tracking/static-1.153",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2970",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20468",
  "ContentUtils": "/ContentUtils/static-1.67715",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2320",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39020",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12842",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12978",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13657",
  "ExportDialog": "/ExportDialog/static-6.10219",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40737",
  "reporting-snowflake": "/reporting-snowflake/static-1.55276",
  "reporting-ui-components": "/reporting-ui-components/static-2.63929",
  "reporting-visualizations": "/reporting-visualizations/static-1.58734",
  "ui-addon-teams": "/ui-addon-teams/static-1.21282",
  "magpie-lib": "/magpie-lib/static-1.5425",
  "magpie-types": "/magpie-types/static-1.4885",
  "simple-logging-lib": "/simple-logging-lib/static-1.2882",
  "navigation-components": "/navigation-components/static-1.17380",
  "ai-studio-lib": "/ai-studio-lib/static-1.11086",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10324",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7823",
  "ui-tool-access": "/ui-tool-access/static-1.9976",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8096",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5583",
  "usage-tracker-public": "/usage-tracker-public/static-1.6977",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3451",
  "persist-promise": "/persist-promise/static-1.3539",
  "reference-resolvers": "/reference-resolvers/static-1.7993",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3775",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.170",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2830",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2274",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4901",
  "purchase-motions-components": "/purchase-motions-components/static-1.5522",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1382",
  "crm-component-utils": "/crm-component-utils/static-1.38559",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5704",
  "customer-data-properties": "/customer-data-properties/static-1.50862",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6703",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "navigation-messaging": "/navigation-messaging/static-1.6707",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9549",
  "cms-field-types": "/cms-field-types/static-1.4639",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7079",
  "crm-message-bus": "/crm-message-bus/static-1.42464",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21455",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9656",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4557",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3863",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6608",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.804",
  "onboarding-tours": "/onboarding-tours/static-1.16307",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13157",
  "academy-common-lib": "/academy-common-lib/static-1.13117",
  "content-assistance-lib": "/content-assistance-lib/static-1.7495",
  "dashboard-lib": "/dashboard-lib/static-1.80758",
  "file-manager-components": "/file-manager-components/static-1.22993",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17976",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17694",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17686",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19526",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8525",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4598",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10749",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8860",
  "user-context": "/user-context/static-1.4931",
  "growth-payments-core": "/growth-payments-core/static-1.24822",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "reporting-reports": "/reporting-reports/static-1.66336",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.556",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28927",
  "react-codemirror": "/react-codemirror/static-1.10458",
  "apps-service-types": "/apps-service-types/static-1.3708",
  "oauth-service-types": "/oauth-service-types/static-1.4078",
  "onboarding-scopes": "/onboarding-scopes/static-1.6295",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4521",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7522",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14621",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3474",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8666",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4331",
  "nav-client-types": "/nav-client-types/static-1.2188",
  "purchase-motions-api": "/purchase-motions-api/static-1.5525",
  "signup-constants": "/signup-constants/static-1.18487",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7866",
  "trials-service-types": "/trials-service-types/static-1.3732",
  "card-properties-lib": "/card-properties-lib/static-1.43620",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36551",
  "crm-actions": "/crm-actions/static-1.6137",
  "crm-cards-data": "/crm-cards-data/static-1.1283",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43021",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8878",
  "customer-data-tracking": "/customer-data-tracking/static-1.6714",
  "calling-global-api": "/calling-global-api/static-1.63791",
  "calling-internal-common": "/calling-internal-common/static-1.31127",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65173",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57467",
  "commerce-products-lib": "/commerce-products-lib/static-1.8948",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3653",
  "crm-links": "/crm-links/static-1.6097",
  "external-options-client-types": "/external-options-client-types/static-1.4014",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.511",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4078",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.463",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3547",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48110",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3820",
  "property-value-citations": "/property-value-citations/static-1.1476",
  "pulse": "/pulse/static-1.347",
  "smart-property-lib": "/smart-property-lib/static-1.6059",
  "tiered-pricing": "/tiered-pricing/static-1.874",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10825",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3996",
  "react-dnd-compat": "/react-dnd-compat/static-1.4452",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5189",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2903",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1381",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.373",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7359",
  "academy-service-client": "/academy-service-client/static-1.3512",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28032",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8216",
  "video-components-external": "/video-components-external/static-1.10668",
  "video-data-lib": "/video-data-lib/static-1.34326",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8398",
  "payment-link-components": "/payment-link-components/static-1.23029",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9718",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6869",
  "data-token-picker": "/data-token-picker/static-1.16098",
  "FileManagerLib": "/FileManagerLib/static-1.38633",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5076",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17094",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8382",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.224",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3013",
  "crm_data": "/crm_data/static-4.91350",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45504",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15177",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18586",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18032",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9877",
  "crm-fe-perf": "/crm-fe-perf/static-1.22736",
  "calling-error-reporting": "/calling-error-reporting/static-1.31133",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10870",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6373",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.341",
  "commerce-permissions": "/commerce-permissions/static-1.590",
  "products-iframe-lib": "/products-iframe-lib/static-1.7418",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9933",
  "directed-graph": "/directed-graph/static-1.771",
  "event-emitter": "/event-emitter/static-1.778",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5368",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9634",
  "policy-lib": "/policy-lib/static-1.6609",
  "react-tinymce": "/react-tinymce/static-1.54711",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9697",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53837",
  "tinymce-plugins": "/tinymce-plugins/static-1.56951",
  "tinymce-themes": "/tinymce-themes/static-1.55807",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1409",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6413",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11570",
  "content-media-compositions": "/content-media-compositions/static-2.15577",
  "media-bridge-lib": "/media-bridge-lib/static-1.18620",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5764",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4917",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3498",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21362",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3674",
  "audio-components": "/audio-components/static-1.5659",
  "FileManagerCore": "/FileManagerCore/static-1.38492",
  "FileManagerImages": "/FileManagerImages/static-1.36144",
  "video-components": "/video-components/static-1.12671",
  "crm_universal": "/crm_universal/static-1.21715",
  "customer-data-email": "/customer-data-email/static-1.17725",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36604",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38974",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11319",
  "customer-data-content": "/customer-data-content/static-1.26928",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54135",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20949",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17232",
  "project-storage": "/project-storage/static-1.4565",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71313",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5160",
  "utility-belt": "/utility-belt/static-1.2371",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11490",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22114",
  "customer-data-rte": "/customer-data-rte/static-1.32522",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5413",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14308",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4946",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37402",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35118",
  "sales-views-client-types": "/sales-views-client-types/static-1.4117",
  "hub-http-contrib": "/hub-http-contrib/static-1.2875",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39922",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5046",
  "layout-dnd-components": "/layout-dnd-components/static-1.12095",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11070",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14094",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8927",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4363",
  "video-embed": "/video-embed/static-1.35160",
  "social-insights-client-types": "/social-insights-client-types/static-1.21453",
  "sequences-lib": "/sequences-lib/static-1.7737",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10179",
  "products-ui-components": "/products-ui-components/static-1.39467",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80033",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8946",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6775",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54151",
  "commerce-products-api": "/commerce-products-api/static-1.2000",
  "SafeStorage": "/SafeStorage/static-1.4234",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56209",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101990",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1373",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7188",
  "draft-content-plugins": "/draft-content-plugins/static-1.27789",
  "ContentData": "/ContentData/static-1.67790",
  "layout-data-lib": "/layout-data-lib/static-1.9395",
  "outpost": "/outpost/static-1.4034",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7594",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.348",
  "property-description-translator": "/property-description-translator/static-1.3687",
  "FireAlarmUi": "/FireAlarmUi/static-1.4363",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4022",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3486",
  "totals-ui-components": "/totals-ui-components/static-1.23078",
  "deal-intel-utils": "/deal-intel-utils/static-1.1377",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14864",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11835",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33539",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3671",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14863",
  "simple-menus-lib": "/simple-menus-lib/static-1.16380"
}
};
